export const keywords = [
  '放屁', 
  '約砲',
  '肏',
  '他媽的','幹你娘','操你媽','你老母',
  '強暴', '強姦', '強吻', 
  'fuck', 'Fuck'
]; //可陸續增加垃圾關鍵字